var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73828 5.25H11.8867L7.73828 1.13672V5.25ZM9.98828 9.01172V7.5H4.01172V9.01172H9.98828ZM9.98828 12V10.4883H4.01172V12H9.98828ZM8.51172 0.0117188L13.0117 4.51172V13.5117C13.0117 13.9102 12.8594 14.2617 12.5547 14.5664C12.25 14.8477 11.8984 14.9883 11.5 14.9883H2.5C2.10156 14.9883 1.75 14.8477 1.44531 14.5664C1.14062 14.2617 0.988281 13.9102 0.988281 13.5117L1.02344 1.48828C1.02344 1.08984 1.16406 0.75 1.44531 0.46875C1.75 0.164062 2.10156 0.0117188 2.5 0.0117188H8.51172Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c74bcbfd5ee22fd44e0aa6fcd9723d8d.svg";
export { ForwardRef as ReactComponent };